import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

import { Page } from '../models/page.model';
import { Role } from '../models/role.model';
import { Observable } from 'rxjs';
import { Authority } from '../models/authority.model';
import { environment } from '@environments/environment';


@Injectable({
  providedIn: 'root'
})
export class AuthorityService {

  private readonly baseUrl = environment.http.apiRoot;
  constructor(private http: HttpClient) { }

  getAuthorityList(params: HttpParams): Observable<Page<Authority>> {
    return this.http.get<Page<Authority>>(`${this.baseUrl}/authorities`, {params});
  }
}
